import { render, staticRenderFns } from "./AnnouncementCountries.vue?vue&type=template&id=c795bdca&"
import script from "./AnnouncementCountries.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports